import React, { useReducer } from 'react';
import InfertilityDetails from './InfertilityDetails';

const PatientDetails = () => {

  return (
    <>
      <InfertilityDetails />
    </>
  );
};

export default PatientDetails;
